import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOpsOrderStatusMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
  status: Types.MerchantOrderStatusEnum;
}>;


export type UpdateOpsOrderStatusMutation = { __typename?: 'Mutation', updateOpsOrderStatus: boolean };


export const UpdateOpsOrderStatusDocument = gql`
    mutation UpdateOpsOrderStatus($filter: OpsOrderFilter, $ids: [ID!], $status: MerchantOrderStatusEnum!) {
  updateOpsOrderStatus(filter: $filter, ids: $ids, status: $status)
}
    `;
export type UpdateOpsOrderStatusMutationFn = Apollo.MutationFunction<UpdateOpsOrderStatusMutation, UpdateOpsOrderStatusMutationVariables>;

/**
 * __useUpdateOpsOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOpsOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpsOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpsOrderStatusMutation, { data, loading, error }] = useUpdateOpsOrderStatusMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateOpsOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpsOrderStatusMutation, UpdateOpsOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpsOrderStatusMutation, UpdateOpsOrderStatusMutationVariables>(UpdateOpsOrderStatusDocument, options);
      }
export type UpdateOpsOrderStatusMutationHookResult = ReturnType<typeof useUpdateOpsOrderStatusMutation>;
export type UpdateOpsOrderStatusMutationResult = Apollo.MutationResult<UpdateOpsOrderStatusMutation>;
export type UpdateOpsOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOpsOrderStatusMutation, UpdateOpsOrderStatusMutationVariables>;